// extracted by mini-css-extract-plugin
module.exports = {"content":"Custom_04_content__2tFk0"};